import PropTypes               from 'prop-types';
import React, { useState }     from 'react';
import { Map, Iterable, List } from 'immutable';

import Grid          from '@mui/material/Grid';
import TextField     from '@mui/material/TextField';
import Autocomplete  from '@mui/material/Autocomplete';

function Dropdown({ ...props }) {
  const input = props.value && props.value.get('value');
  const uniqOptions = [
    ...new Set(
      props.dropdownOptions.map((option) => { return option; })
    ),
  ];

  function setInput(value) {
    const chosenValue = value.currentTarget.innerHTML;
    if (props.dropdownOptions.includes(chosenValue)) {
      props.onChange(props.name, new Map({ text: chosenValue }));
    } else {
      props.onChange(props.name, new Map({ text: '' }));
    }
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Autocomplete
          options={uniqOptions}
          getOptionLabel={(option) => option.toString()}
          renderInput={(params) => (
            <TextField {...params} placeholder={t('eos.landing_page.text.dropdown_instruction')} />
          )}
          clearOnBlur={false}
          disableCloseOnSelect={false}
          disabled={props.disabled}
          onChange={(e) => setInput(e)}
          value={input}
        />
      </Grid>
    </Grid>
  );
}

Dropdown.defaultProps = {
  value:    null,
  name:     null,
  onChange: null,
  options:  new List(),
  disabled: false,
};

Dropdown.propTypes = {
  value:    PropTypes.objectOf(Iterable),
  name:     PropTypes.string,
  onChange: PropTypes.func,
  options:  PropTypes.objectOf(Iterable),
  disabled: PropTypes.bool,
};

export default Dropdown;
